import React from 'react';
import { AlertMessagePrimary, AlertMessage } from '../popup';
import { AlertContent, Types } from '../../../../../../CommonComponents/ContentMessages';
const Alerts = (props) => {
    return (
        <>
            <AlertMessagePrimary
                className="altExitExchange"                
                title={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Exit Exchange"}
                        property={"field_header"}
                    />
                }
                visible={props.isExit}
                onCancel={(e) => props.setExit(false)}
                onOk={props.handleExitConfirmation}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Exit Exchange"}
                        property={"field_alert_button2_text"}
                    />
                }
                okText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Exit Exchange"}
                        property={"field_alert_button1_text"}
                        isButton={true}
                    />
                }
            >
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Exit Exchange"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
                />
            </AlertMessagePrimary>
            <AlertMessagePrimary
                className="altCancelExchange" 
                title={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Exchange"}
                        property={"field_header"}
                    />
                }
                visible={props.isCancel}
                onCancel={(e) => props.setCancel(false)}
                onOk={props.handleCancelConfirmation}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Exchange"}
                        property={"field_alert_button2_text"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Exchange"}
                        property={"field_alert_button1_text"}
                        isButton={true}
                    />
                }
            >
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Cancel Exchange"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
                />
            </AlertMessagePrimary>
            <AlertMessagePrimary
                className="altCancelSpawn"
                title='Cancel'
                visible={props.isCancelSpawn}
                onCancel={(e) => props.setCancelSpawn(false)}
                onOk={props.handleExitSpawn}>
                <p>Are you sure you want to exit the flow? Your data will not be saved.</p>
                <div>Do you want to continue?</div>
            </AlertMessagePrimary>
            <AlertMessage
                className="altPendingTransaction"                
                title={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Pending Transaction"}
                        property={"field_header"}
                        defaultMessage={"Alert"}
                    />
                }
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Pending Transaction"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"CLOSE"}
                        isButton={true}
                    />
                }
                visible={props.isPendingTransactionForRellocationExchange}
                onCancel={(e) => props.setPendingTransactionForRellocationExchange(false)}
            >   
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Pending Transaction"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"Due to a pending transaction on your account, you cannot submit a reallocation exchange at this time.Please wait for the pending transaction to complete or submit a custom exchange.View your pending transactions on the Account summary page"}
                />
            </AlertMessage>
            <AlertMessage
                className="altPendingTiff"                
                title={<AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Pending TIFF"}
                    property={"field_header"}
                    defaultMessage={"Alert"}
                />}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Pending TIFF"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"CLOSE"}
                        isButton={true}
                    />
                }
                visible={props.isPendingTiff}
                onCancel={(e) => props.setIsTiffClicked(false)}
            >
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Pending TIFF"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"You have a pending TIFF exchange. You may continue once the exchange is completed."}
                /> 
            </AlertMessage>
            <AlertMessage
                className="altActiveRecurring"                
                title={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Active Recurring"}
                        property={"field_header"}
                        defaultMessage={"Alert"}
                    />
                }
                visible={props.isMaxRecurring}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Active Recurring"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"OKAY"}
                        isButton={true}
                    />
                }
                onCancel={(e) => props.setMaxRecurring(false)}
            >
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Active Recurring"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"You have reached the limit for active recurring exchanges. To enter a new recurring exchange, you must cancel an active recurring exchange."}
                /> 
            </AlertMessage>
            <AlertMessagePrimary
                className="altChangeSelType"                
                title={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Change Select Type"}
                        property={"field_header"}
                    />
                }
                visible={props.isUpdateScheduleTypeAfterChanges.display}
                onCancel={(e) => props.handleUpdateScheduleTypeAfterChanges(false)}
                onOk={(e) => props.handleUpdateScheduleTypeAfterChanges(true)}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Change Select Type"}
                        property={"field_alert_button2_text"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Change Select Type"}
                        property={"field_alert_button1_text"}
                        isButton={true}
                    />
                }
            >
                 <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Change Select Type"}
                    property={"field_description"}
                    html={true}
                />
            </AlertMessagePrimary>
            {/*alerts specific for step 1 */}
            {props.isRecommendFrom && <>
                <AlertMessage
                    className="altLowBalance"
                    title={
                        <AlertContent
                            page={"Recommend an Exchange"}
                            type={[Types.PAGE_ALERTS]}
                            keyProperty={"Low Balanace"}
                            property={"field_header"}
                        />
                    }
                    visible={props.isBalanceDiffWithPendingTransaction}
                    onCancel={(e) => props.setBalanceDiffWithPendingTransaction(false)}
                    cancelText={
                        <AlertContent
                            page={"Recommend an Exchange"}
                            type={[Types.PAGE_ALERTS]}
                            keyProperty={"Low Balanace"}
                            property={"field_alert_button1_text"}
                            isButton={true}
                        /> 
                    }
                    maskClosable={false}
                >
                     <AlertContent
                            page={"Recommend an Exchange"}
                            type={[Types.PAGE_ALERTS]}
                            keyProperty={"Low Balanace"}
                            property={"field_description"}
                            html={true}
                        />
                    
                </AlertMessage>
            </>}
        </>
    );
};

export default Alerts;